export default function RoyalPurpleBox() {
  const path = window.location.pathname;
  const version = path.split('/')[1];

  if (version !== 'v2' ) {
    return null;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const market = urlParams.get("market") || "";
  const royalPurpleBoxMarkets= process.env.REACT_APP_ROYAL_PURPLE_BOX_MARKETS || "";
  const isImageAvailable = !!market && royalPurpleBoxMarkets.split(',').includes(market.toUpperCase());

  if (!isImageAvailable) {
    return null;
  }

  return (
    <div className="purpleBox">
      <img
        srcSet={`
          images/${market.toUpperCase()}_RoyalPurpleBox-desktop.webp 800w, images/${market.toUpperCase()}_RoyalPurpleBox-desktop.png 800w,
          images/${market.toUpperCase()}_RoyalPurpleBox-tablet.webp 500w, images/${market.toUpperCase()}_RoyalPurpleBox-tablet.png 500w,
          images/${market.toUpperCase()}_RoyalPurpleBox-mobile.webp 280w, images/${market.toUpperCase()}_RoyalPurpleBox-mobile.png 280w
        `}
        sizes="
          (max-width: 280px) 280w,
          (max-width: 479px) 480w,
          800w
        "
        src={`images/${market.toUpperCase()}_RoyalPurpleBox-desktop.png`}
        alt="Royal Purple Box"
      />
    </div>
  );
}
